import type { ServerError } from '@apollo/client';

import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	PetitionDetailsPageTrackPromotionEvent,
	type PetitionDetailsPageTrackPromotionEventMutation,
	type PetitionDetailsPageTrackPromotionEventMutationVariables,
} from './promotionEvent.graphql';

type EventType = PetitionDetailsPageTrackPromotionEventMutationVariables['input']['eventType'];
type EventData = Omit<PetitionDetailsPageTrackPromotionEventMutationVariables['input'], 'eventType'>;

function getReportParams(error: unknown) {
	if (error instanceof Error) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
		if ((error as any).statusCode) {
			const response = error as ServerError;
			return {
				status: response.statusCode,
				message: response.message,
			};
		}
		return {
			message: error.message,
		};
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	if ((error as any).status) {
		const response = error as Response;
		return {
			status: response.status,
			message: response.statusText,
		};
	}
	return {};
}

export async function trackPromotionEvent(
	eventType: EventType,
	eventData: EventData,
	{ gql: { fetch }, errorReporter: { report } }: UtilityContext,
): Promise<void> {
	try {
		await fetch<
			PetitionDetailsPageTrackPromotionEventMutation,
			PetitionDetailsPageTrackPromotionEventMutationVariables
		>({
			query: PetitionDetailsPageTrackPromotionEvent,
			variables: {
				input: {
					eventType,
					...eventData,
				},
			},
			rejectOnError: false,
		});
	} catch (error) {
		void report({
			error: new Error('Error tracking promotion event', { cause: error }),
			params: getReportParams(error),
		});
	}
}
